import { createFileRoute } from "@tanstack/react-router";
import { AdServiceLanding } from "@/components/ads/AdServiceLanding";
import klippningSkaggAsset from "@/assets/opt/klippning-skagg-tailors-barber.webp";
export const Route = createFileRoute("/barberare-stockholm-ahlens-city/har-skagg")({
  head: () => ({
    meta: [
      { title: "Hår & Skägg-paket · 680 kr | Tailor's Barber Åhléns City" },
      { name: "description", content: "Herrklippning + skäggtrimning i Stockholm City för 680 kr (värde 830 kr separat). Boka hos Tailor's Barber Åhléns City – 1 min från T-Centralen." },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: () => (
    <AdServiceLanding
      reviewService="hår-skägg"
      heroImage={klippningSkaggAsset}
      heroImageAlt="Herrklippning och skäggtrimning hos Tailor's Barber Åhléns City"
      eyebrow="Populäraste paketet · Åhléns City · 1 min från T-Centralen"
      h1="Herrklippning & Skäggtrimning i Stockholm"
      priceBadge="680 kr"
      salon="ahlens-city"
      primaryCtaLabel="Boka Hår & Skägg →"
      primaryCtaHref="https://www.bokadirekt.se/boka-tjanst/tailors-barber-stockholm-ahlens-city-37678/klippning-skaggtrimning-1247224?utm_source=google&utm_medium=cpc&utm_campaign=ahlens-city"
      secondary="Spara vs. separat: 450 + 380 = 830 kr → Paketet 680 kr"
      included={[
        { title: "Konsultation", desc: "Hår och skägg planeras ihop för helhetslook." },
        { title: "Herrklippning", desc: "Klassisk eller modern, sax/maskin." },
        { title: "Skäggtrimning & formning", desc: "Anpassad till din ansiktsform." },
        { title: "Styling & finish", desc: "Komplett grooming från topp till tå." },
      ]}
      priceBox="Komplett Hår & Skägg-paket: 680 kr (värde 830 kr separat)"
      faq={[
        { q: "Hur lång tid tar paketet?", a: "Ungefär 60 minuter." },
        { q: "Vad är skillnaden mot att boka separat?", a: "Paketet är ihopkopplat och kostar 680 kr mot 830 kr separat." },
        { q: "Kan jag få skin fade som del av paketet?", a: "Ja, ange vid bokning vilken typ av klippning du vill ha." },
        { q: "Drop-in eller bokning?", a: "Bokning rekommenderas för paketbehandlingar." },
      ]}
    />
  ),
});
